module.exports = __webpack_public_path__ + "static/media/chat-square-dots.20f9200d.svg";